var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ionos-inline-switch"},[_c('v-switch',_vm._g(_vm._b({class:{ 'without-label': _vm.withoutLabel },attrs:{"hide-details":"","text":"","inset":"","small":""}},'v-switch',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }